'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import TradeMemberAssistanceBlockContent from './TradeMemberAssistanceBlockContent';
import getObfuscatedEmailAction from '@/app/_lib/actions/GetObfuscatedEmailAction';
const TradeMemberAssistanceBlock = () => {
  const $ = _c(4);
  const [emailObfuscated, setEmailObfuscated] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      getObfuscatedEmailAction("INFO_EMAIL").then(setEmailObfuscated);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== emailObfuscated) {
    t2 = <TradeMemberAssistanceBlockContent emailObfuscated={emailObfuscated} />;
    $[2] = emailObfuscated;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TradeMemberAssistanceBlock;